import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const AdminSideBar = ({ menuContent, isMinimized }) => {
  const location = useLocation();

  return (
    <aside
      className={`main-sidebar sidebar-light-primary ${
        isMinimized ? "minimized" : ""
      }`}
      style={{
        width: isMinimized ? "80px" : "250px",
        position: "fixed",
        height: "100vh",
        backgroundColor: "#14233D",
        overflow: "hidden",
      }}
    >
      <div
        className="sidebar"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Logo/Header */}
        {!isMinimized ? (
          <div
            className="user-panel mt-3 pb-3 mb-2 d-flex justify-content-center align-items-middle"
            style={{ height: "75px" }}
          >
            <div className="mb-32">
              <img
                src={
                  process.env.PUBLIC_URL + "/assets/images/logo/logo-two.png"
                }
                alt="logo"
                className="pe-32 ps-30 pt-16 pb-16"
              />
            </div>
          </div>
        ) : (
          <div className="text-center py-2 mt-24 mb-24">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/appname_side.png"}
              alt="applogo"
              style={{ width: "50px", height: "50px", objectFit: "contain" }}
            />
          </div>
        )}

        {/* Scrollable nav */}
        <nav
          className="mt-2"
          style={{
            overflowY: "auto",
            overflowX: "hidden",
            flex: 1,
            paddingRight: "8px",
          }}
        >
          <ul
            className={`nav nav-sidebar flex-column text-light ${
              isMinimized ? "minimized-text" : ""
            }`}
            data-widget="treeview"
            data-accordion="false"
          >
            {menuContent?.map((menuItem) => {
              if (menuItem.isTitle) {
                if (isMinimized) return null;
                return (
                  <li key={menuItem.key} className="nav-header">
                    <p
                      className="text-white fw-bold fs- mb-24"
                      style={{ marginLeft: "20px" }}
                    >
                      {menuItem.text}
                    </p>
                  </li>
                );
              }

              const isActive = location.pathname === menuItem.url;

              return (
                <SidebarItem
                  key={menuItem.key}
                  menuItem={menuItem}
                  isActive={isActive}
                  isMinimized={isMinimized}
                  location={location}
                />
              );
            })}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

/*  Sidebar Item Component (handles hover per item) */
const SidebarItem = ({ menuItem, isActive, isMinimized, location }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (menuItem.children) {
    return (
      <MenuContent
        menuItem={menuItem}
        isMinimized={isMinimized}
        location={location}
      />
    );
  }

  return (
    <li
      className="nav-item"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        to={menuItem.url || "#"}
        className={`nav-link d-flex ${isActive ? "active" : ""}`}
        style={{ paddingTop: "18px", fontSize: "18px" }}
      >
        {typeof menuItem.Icon === "string" ? (
          <img
            src={
              process.env.PUBLIC_URL +
              (isHovered || isActive
                ? menuItem.hoverIcon || menuItem.Icon
                : menuItem.Icon)
            }
            alt={menuItem.text}
            style={{
              width: "20px",
              height: "20px",
              marginRight: "8px",
              objectFit: "contain",
            }}
          />
        ) : (
          <menuItem.Icon size={20} style={{ marginRight: "8px" }} />
        )}
        {!isMinimized && <p className="mb-0">{menuItem.text}</p>}
      </Link>
    </li>
  );
};

/*  Submenu Component */
const MenuContent = ({ menuItem, isMinimized, location }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const isAnyChildActive = menuItem.children?.some(
    (child) => child.url === location.pathname
  );
  const isParentActive = location.pathname === menuItem.url;
  const isActive = isParentActive || isAnyChildActive;

  useEffect(() => {
    if (isAnyChildActive) {
      setShowSubMenu(true);
    }
  }, [location.pathname, isAnyChildActive]);

  const handleToggleMenuClick = () => {
    setShowSubMenu(!showSubMenu);
  };

  return (
    <li
      className={`nav-item ${isActive ? "active" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        to={"#"}
        className={`nav-link d-flex ${isActive ? "active" : ""}`}
        onClick={handleToggleMenuClick}
        style={{ fontSize: "18px" }}
      >
        {typeof menuItem.Icon === "string" ? (
          <img
            src={
              process.env.PUBLIC_URL +
              (isHovered || isActive
                ? menuItem.hoverIcon || menuItem.Icon
                : menuItem.Icon)
            }
            alt={menuItem.text}
            style={{
              width: "20px",
              height: "20px",
              marginRight: isMinimized ? "0px" : "8px",
              objectFit: "contain",
            }}
          />
        ) : (
          <menuItem.Icon
            size={20}
            style={{ marginRight: isMinimized ? "0px" : "8px" }}
          />
        )}
        {!isMinimized && (
          <p
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            {menuItem.text}
            <i
              className={`fas ${
                !showSubMenu ? "fa-angle-right" : "fa-angle-down"
              }`}
            ></i>
          </p>
        )}
      </Link>

      {/* Submenu */}
      {!isMinimized && (
        <ul
          className="nav nav-treeview"
          style={{ display: showSubMenu ? "block" : "none" }}
        >
          {menuItem.children?.map((childItem, index2) => {
            const isChildActive = location.pathname === childItem.url;
            return (
              <li
                className={`nav-item ${isChildActive ? "active" : ""}`}
                key={index2}
              >
                <Link
                  to={childItem.url || "#"}
                  className={`nav-link d-flex ${isChildActive ? "active" : ""}`}
                >
                  <i
                    className="fas fa-angle-right nav-icon"
                    style={{ marginLeft: "20px" }}
                  ></i>
                  <p className="mb-0" style={{ marginLeft: "10px" }}>
                    {childItem.text}
                  </p>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};


export default AdminSideBar;
